<template>
  <div class="route-optimization-tabs">
    <b-button
      v-for="tab in tabMappings"
      :key="tab.key"
      variant="light"
      class="d-flex align-items-center gap-2"
      :class="{ active: tab.key == activeTab }"
      :disabled="isLoading"
      @click="handleClickTab(tab.key)"
    >
      {{ tab.name }}
      <McBadge
        v-if="getTotalDeliveryOrder(tab.key)"
        :text="getTotalDeliveryOrder(tab.key)"
        variant="primary"
        type="button"
      />
    </b-button>
  </div>
</template>

<script>
import McBadge from '@/components/McBadge'
import { mapState } from 'vuex'

export default {
  name: 'TimelineTabs',
  components: {
    McBadge,
  },
  props: {
    activeTab: {
      type: String,
      default: 'SERVED',
    },
    isLoading: {
      type: Boolean,
    },
  },
  emits: ['update:activeTab', 'showData'],
  computed: {
    ...mapState('routeOptimization', ['showResponse', 'unservedShowResponse']),
    tabMappings() {
      return [
        {
          key: 'SERVED',
          name: this.$t('routeOptimization.tab.served'),
        },
        {
          key: 'UNSERVED',
          name: this.$t('routeOptimization.tab.unserved'),
        },
      ]
    },
    getTotalDeliveryOrder() {
      return (key) => {
        if (
          this.showResponse?.status?.raw_type === 'PENDING' ||
          this.unservedShowResponse?.metadata == undefined
        ) {
          return '0'
        }

        return key === 'SERVED'
          ? `${this.unservedShowResponse?.metadata?.total_served}`
          : `${this.unservedShowResponse?.metadata?.total_unserved}`
      }
    },
  },
  methods: {
    handleClickTab(tabKey) {
      if (tabKey == this.activeTab || tabKey === undefined) return

      this.$emit('update:activeTab', tabKey)
    },
  },
}
</script>

<style lang="scss" scoped>
.route-optimization-tabs {
  display: flex;
  gap: 8px;
  overflow-x: auto;

  & > button {
    height: 36px;
    flex-shrink: 0;
    color: $mep-color-text;
    font-weight: 500;
    transition: none;
    background: none;
    outline: none;
    border: none;
    border-radius: 4px;
    padding: 8px 20px;

    &:hover {
      background-color: $mep-secondary-100;
      color: $mep-color-text-400;
    }

    &:focus {
      outline: none;
    }

    &:disabled {
      color: #67718b;
    }
  }

  & > button.active {
    border: 1px solid $mep-primary;
    background-color: $mep-secondary-100;
    color: $mep-primary;
    font-weight: 600;
  }
}
</style>
